import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SlackIntegrationEffects } from './slack-integration-store/slack-integration-effects';
import {
  SlackIntegrationNamespace,
  SlackIntegrationReducer,
} from './slack-integration-store/slack-integration-store';

@NgModule({
  imports: [
    StoreModule.forFeature(SlackIntegrationNamespace, SlackIntegrationReducer),
    EffectsModule.forFeature([SlackIntegrationEffects]),
  ],
})
export class SlackIntegrationDataModule {}
